var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.121,
    height: 20.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Arrow 2 Right"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 497",
    d: "M20.061 10.25l-9.5-9.5-9.5 9.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 498",
    d: "M10.561 19.75v-19"
  }))));
}
export default SvgArrowUp;